export const DotIcon: React.FC<React.SVGAttributes<{}>> = ({ color = "#121923", ...props }) => (
  
  <svg width="20px" height="20px"
  {...props}
   viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12.5" cy="12.5" r="1.5" fill={color} stroke={color} stroke-width="1.2"/>
</svg>
);
